import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'KM Consulting transformed our digital presence completely. Their attention to detail and technical expertise is unmatched.',
  author: 'Sarah Johnson',
  role: 'CEO, TechStart Ltd',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
}, {
  quote: 'Working with the team was a breeze. They understood our vision perfectly and delivered a product that exceeded our expectations.',
  author: 'Michael Okonkwo',
  role: 'Director, Future Finance',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&auto=format&fit=crop'
}, {
  quote: "The best investment we've made this year. Our new website has increased our conversion rate by 150%.",
  author: 'David Smith',
  role: 'Marketing Head, Global Corp',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop'
}];
export function Testimonials() {
  return <Section className="bg-[#091220]" data-id="element-277">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-278">
        <span className="text-[#d8a43e] font-mono text-sm tracking-widest uppercase" data-id="element-279">
          // Testimonials
        </span>
        <h2 className="mt-3 text-4xl font-bold text-white" data-id="element-280">
          What Our Clients Say
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-281">
        {testimonials.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white/[0.02] backdrop-blur-md p-8 rounded-2xl border border-white/5 relative hover:bg-white/[0.04] transition-colors group" data-id="element-282">
            <Quote className="absolute top-8 right-8 w-10 h-10 text-[#d8a43e]/20 group-hover:text-[#d8a43e]/40 transition-colors" data-id="element-283" />

            <p className="text-gray-300 mb-8 relative z-10 italic leading-relaxed" data-id="element-284">
              "{item.quote}"
            </p>

            <div className="flex items-center gap-4 pt-6 border-t border-white/5" data-id="element-285">
              <div className="relative" data-id="element-286">
                <div className="absolute inset-0 bg-[#d8a43e] rounded-full blur opacity-20" data-id="element-287" />
                <img src={item.image} alt={item.author} className="w-12 h-12 rounded-full object-cover border border-[#d8a43e]/30 relative z-10" data-id="element-288" />
              </div>
              <div data-id="element-289">
                <h4 className="font-bold text-white" data-id="element-290">{item.author}</h4>
                <p className="text-xs text-[#d8a43e] font-mono uppercase" data-id="element-291">
                  {item.role}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}